import {
   getECLToken,
   sourceOneRestURL,
   sourceOneRESTFetchConfig,
} from "./fetchVariables";

export default async function sourceOneRestRequest(params, extraConfig = {}) {
   const eclToken = await getECLToken();
   const res = await fetch(sourceOneRestURL, {
      ...sourceOneRESTFetchConfig(eclToken),
      body: JSON.stringify(params),
      ...extraConfig,
   });

   return res.json();
}
